import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styled from "styled-components";

import { ArrowRight, MemberCrown, MemberDiamond, MemberStar } from "@components";
import { selectMerchant } from "@redux";
import { Progress } from "antd";
import { useState } from "react";

interface IProps {
    handleClickNext: (id: string) => void;
    maintainPoint: number;
    firstTier: boolean;
    percent: number;
    date?: string;
    tierColor?: string;
    tierIcon?: string;
    isBalance?: boolean;
}

export const ComponentMembershipTier = (props: IProps) => {
    //hooks
    const { t } = useTranslation();
    //redux page
    const { memberShipTiers, superAdminTier } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    //page props
    const {
        handleClickNext,
        maintainPoint,
        firstTier,
        percent,
        date,
        tierColor,
        tierIcon,
        isBalance,
    } = props;
    const [disabled, setDisabled] = useState(true);
    const onChange = (checked: boolean) => {
        setDisabled(checked);
    };
    return (
        <StyledMemberShipTier mainColor={tierColor || "gray"}>
            {!firstTier && !isBalance && (
                <div className="layout-more-point">
                    <div className="text-more-point">
                        <span className="point">{maintainPoint <= 0 ? "100%" : maintainPoint}</span>
                        <span className="text">{maintainPoint > 0 && "more point"}</span>
                        to maintain status by {date}
                    </div>
                    <div className="level-more-point">Welcome level</div>
                    <div className="progress-more-point">
                        {/* <Slider defaultValue={percent} disabled={disabled} /> */}
                        <Progress
                            percent={percent}
                            showInfo={false}
                            strokeColor={tierColor || "gray"}
                        />
                        <span>
                            {tierIcon === "star" && <MemberStar color="white" />}
                            {tierIcon === "diamond" && <MemberDiamond color="white" />}
                            {tierIcon === "crown" && <MemberCrown color="white" />}
                        </span>
                    </div>
                </div>
            )}

            <div className="title text-sub-header">{t("page.member_ShipTier")}</div>
            <div className="desc text-body">{t("page.member_shipTier_desc")}</div>
            {memberShipTiers?.map((membershipTier) => {
                return (
                    <div key={membershipTier._id}>
                        {!membershipTier.isDefault && (
                            <div
                                className="memberShipTiers"
                                key={membershipTier._id}
                                onClick={() => handleClickNext(membershipTier._id)}
                            >
                                <div className="membershipTiers__info">
                                    <StyleIconTier mainColor={membershipTier?.color}>
                                        {membershipTier?.icon === "star" && (
                                            <MemberStar color={"white"} />
                                        )}
                                        {membershipTier?.icon === "diamond" && (
                                            <MemberDiamond color="white" />
                                        )}
                                        {membershipTier?.icon === "crown" && (
                                            <MemberCrown color="white" />
                                        )}
                                    </StyleIconTier>
                                    <div className="rank">
                                        <div className="name text-sec-sub-header">
                                            {membershipTier.membershipName}
                                        </div>
                                        <div className="membershipTiers_desc text-body">
                                            {t("page.earn_points_in_a_year")}
                                            <span className="eng">{`${" "}
                                            ${isBalance
                                                    ? membershipTier.pointThreshold
                                                    : membershipTier?.tierSpent[0]?.Attaintier
                                                }
                                            ${" "}`}</span>
                                            {merchant?.advanceSettings?.tier?.isTierBySale
                                                ? t("page.baht")
                                                : t("page._points")}
                                        </div>
                                    </div>
                                </div>
                                <div className="arrow_right">
                                    <ArrowRight />
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </StyledMemberShipTier>
    );
};

const StyledMemberShipTier = styled.div<{ mainColor: string }>`
    width: 100%;
    margin: 0 auto;
    padding: 24px;
    background-color: ${(p) => p.theme.colors.card};
    border-radius: 12px;
    box-shadow: rgb(215 215 215) 0px 0px 4px 0px;
    min-height: 75vh;
    .layout-more-point {
        padding-bottom: 15px;
        margin-bottom: 15px;
        border-bottom: 1px solid #e1e1e1;
        .ant-slider-track {
            background-color: ${(p) => p.mainColor};
        }
        .ant-slider-handle {
            background-color: ${(p) => p.mainColor};
            border-color: ${(p) => p.mainColor};
        }
        .text-more-point {
            color: #525257;
            font-size: 13px;
            margin-bottom: 5px;
            span {
                font-weight: 600;
                font-size: 16px;
            }
            .text {
                color: #000000;
                margin-right: 5px;
            }
            .point {
                color: ${(p) => p.mainColor};
                margin-right: 5px;
            }
        }
        .level-more-point {
            padding-left: 17px;
            color: #9b9b9b;
            font-size: 11px;
            line-height: 16px;
            background-image: url(../../images/ic-star.svg);
            background-size: 12px;
            background-repeat: no-repeat;
            background-position: center left;
            margin-bottom: 15px;
        }
        .progress-more-point {
            position: relative;
            padding-right: 45px;
            span {
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                display: flex;
                justify-content: center;
                align-items: center;
                width: 28px;
                height: 28px;
                /* background-color: #BBBEC2; */
                background-color: ${(p) => p.mainColor};
                border-radius: 100%;
                img {
                    width: 17px;
                    height: 17px;
                }
            }
            .ant-progress-inner {
                background-color: #e8e8e8;
            }
            /* .ant-progress-success-bg, .ant-progress-bg {
                background-color: #336C51;
            } */
        }
    }
    .title {
        font-style: normal;
        color: ${(p) => p.theme.colors.color};
        padding: 0x 0 5px 0;
    }
    .desc {
        font-style: normal;
        line-height: 1.5rem;
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 1em;
    }
    .memberShipTiers {
        display: flex;
        padding: 12px 16px 12px 16px;
        align-items: center;
        justify-content: space-between;
        background-color: #f7f7f7;
        border-radius: 12px;
        margin-bottom: 5px;
        .membershipTiers__info {
            display: flex;
            align-items: center;
            .icon-tier {
                width: 36px;
                height: 36px;
                display: flex;
                border: 1px solid rgba(0, 0, 0, 0.2);
                margin-right: 20px;
                border-radius: 100%;
                align-items: center;
                justify-content: center;
                background-color: #d44343;
                position: relative;

                img {
                    width: 21px;
                    height: 21px;
                }
            }
        }
        .rank {
            .name {
                word-break: break-word;
                font-style: normal;
                line-height: 1.5rem;
                color: ${(p) => p.theme.colors.color};
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                span {
                    font-size: 10px;
                    line-height: 12px;
                    color: #fff;
                    background-color: #ed773a;
                    padding: 2px 6px 2px 6px;
                    border-radius: 4px;
                    position: relative;
                    top: -3pxx;
                    margin-left: 10px;
                }
            }
            .membershipTiers_desc {
                font-style: normal;
                line-height: 24px;
                color: #7b7b7b;
            }
        }
    }
    .memberShipTiers:last-child {
        border-bottom: initial;
    }
    .arrow_right {
        cursor: pointer;
    }
    .image {
        width: 38px;
        margin-right: 20px;
    }
`;

const StyleIconTier = styled.div<{ mainColor: string }>`
    width: 36px;
    height: 36px;
    display: flex;
    border: 1px solid rgba(0, 0, 0, 0.2);
    margin-right: 20px;
    border-radius: 100%;
    align-items: center;
    justify-content: center;
    background-color: ${(p) => p.mainColor};
    position: relative;
    img {
        width: 21px;
        height: 21px;
    }
    &:after {
        content: "";
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        background: rgb(255, 255, 255);
        background: linear-gradient(
            0deg,
            rgba(255, 255, 255, 0) 60%,
            rgba(255, 255, 255, 0.4) 100%
        );
        position: absolute;
        left: 1px;
        top: 1px;
        border-radius: 100%;
    }
`;
